<section class="profile-notifications">

    <app-profile-section-header title="Notificaciones"
                                subtitle="Elige cómo quieres recibir los avisos relacionados con tus seguros">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
            <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2H4.5L6 16z" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 20a2 2 0 0 0 4 0" stroke-linecap="round"/>
        </svg>
    </app-profile-section-header>

    <div class="pn-body">
        <p class="pn-label">Selecciona tu canal de notificaciones preferido:</p>

        <div class="pn-grid">
            <button type="button" class="pn-card"
                    [class.pn-card--selected]="selected === 'SMS'"
                    (click)="select('SMS')">
                <span class="pn-card-check" *ngIf="selected === 'SMS'">
                    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <path d="M3 8l3 3 7-7" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="pn-card-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="pn-card-title">SMS</span>
                <span class="pn-card-desc">Recibe notificaciones por mensaje de texto</span>
            </button>

            <button type="button" class="pn-card"
                    [class.pn-card--selected]="selected === 'EMAIL'"
                    (click)="select('EMAIL')">
                <span class="pn-card-check" *ngIf="selected === 'EMAIL'">
                    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <path d="M3 8l3 3 7-7" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="pn-card-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                        <rect x="3" y="5" width="18" height="14" rx="2"/>
                        <path d="M3 7l9 6 9-6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="pn-card-title">Email</span>
                <span class="pn-card-desc">Recibe notificaciones por correo electrónico</span>
            </button>

            <button type="button" class="pn-card"
                    [class.pn-card--selected]="selected === 'NINGUNO'"
                    (click)="select('NINGUNO')">
                <span class="pn-card-check" *ngIf="selected === 'NINGUNO'">
                    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <path d="M3 8l3 3 7-7" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="pn-card-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/>
                    </svg>
                </span>
                <span class="pn-card-title">Ninguno</span>
                <span class="pn-card-desc">No recibir notificaciones</span>
            </button>
        </div>
    </div>

</section>
